(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/banner_common/banner-helpers/assets/javascripts/accessibility-helpers.js') >= 0) return;  svs.modules.push('/components/banner_common/banner-helpers/assets/javascripts/accessibility-helpers.js');

'use strict';

const isServer = typeof exports === 'object';

const resolveSportFromClassName = className => {
  switch (className) {
    case 'game-sport':
      return 'Sport';
    case 'game-basketball':
      return 'Basket';
    case 'table-games':
      return 'Casino';
    case 'game-soccer':
      return 'Fotboll';
    case 'game-handball':
      return 'Handboll';
    case 'icon-horse':
      return 'Hästar';
    case 'game-floorball':
      return 'Innebandy';
    case 'game-hockey':
      return 'Ishockey';
    case 'game-tennis':
      return 'Tennis';
    case 'game-winter':
      return 'Vintersport';
    default:
      return '';
  }
};

const ariaRoleDescription = (sportIconClassName, layoutConfig) => {
  const sportIcon = resolveSportFromClassName(sportIconClassName);
  const branding = (layoutConfig.branding || '').replace('-', '');
  let description = 'Banner.';
  if (branding) {
    description += " ".concat(branding.toLowerCase().charAt(0).toUpperCase()).concat(branding.slice(1), ".");
  }
  if (sportIcon) {
    description += " ".concat(sportIcon, ".");
  }
  return description;
};
const exported = {
  ariaRoleDescription
};
if (isServer) {
  module.exports = exported;
} else {
  svs.banner_common.banner_helpers.accessibilityHelpers = exported;
}

 })(window);